const correctAnswerId = 2;

const evaluateAnswer = (selectedAnswerId) => selectedAnswerId === correctAnswerId;

const Demo = { evaluateAnswer, correctAnswerId };

export default Demo;
